import { Divider, Typography } from '@mui/material'
import { ScoreBar } from 'components/atoms/ShadedScoreDisplayBar'
import colors from 'styles/colors'
import { ColStack } from 'components/atoms/container/InCardStack'
import { useTranslation } from 'react-i18next'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'

const BehaviourDetails = ({ behaviourData }) => {
  const { t } = useTranslation()

  return (
    <>
      {behaviourData && (
        <ColStack spacing={8}>
          <Typography
            variant='body1KindaSmall'
            fontWeight={500}
            width={672}
            color='textSecondary'>
            {behaviourData?.description}
          </Typography>

          <BoxWithBackground
            padding={4}
            borderRadius={2}
            backgroundColor={colors.MutedTeal50}
            width={'100%'}>
            <ColStack spacing={4}>
              <Typography variant='eyebrow'>
                {t('assessmentTimeline.overallAverages')}
              </Typography>

              <ScoreBar
                score={behaviourData?.avgSelfRating || 0}
                label={t('goalsArea.self')}
                labelTypoProps={{
                  variant: 'h6'
                }}
                scoreTypoProps={{
                  variant: 'h6'
                }}
              />

              <ScoreBar
                score={behaviourData?.avgOthersRating || 0}
                label={t('goalsArea.others')}
                selfScore={false}
                labelTypoProps={{
                  variant: 'h6'
                }}
                scoreTypoProps={{
                  variant: 'h6'
                }}
              />
            </ColStack>
          </BoxWithBackground>

          <Divider
            sx={{
              borderColor: colors.Grey100,
              width: '100%'
            }}
          />

          <Typography variant='h4'>
            {t('assessmentBehaviour.questions')}
          </Typography>

          <ColStack spacing={12}>
            {behaviourData.questions.map((value, index) => (
              <ColStack key={`question-${index}`} spacing={4}>
                <Typography
                  fontWeight={500}
                  lineHeight={'150%'}
                  color='textSecondary'>
                  {index + 1}. {value.selfQuestion}
                </Typography>

                <ScoreBar
                  score={value.selfScore || 0}
                  label={t('goalsArea.self')}
                />

                <ScoreBar
                  score={value.othersScore || 0}
                  label={t('goalsArea.others')}
                  selfScore={false}
                />
              </ColStack>
            ))}
          </ColStack>
        </ColStack>
      )}
    </>
  )
}

export default BehaviourDetails
